export const errorPageTranslationKeys = {
  errorPage404Description: 'error-page.404-description',
  errorPage404Title: 'error-page.404-title',
  errorPage500Description: 'error-page.500-description',
  errorPage500Title: 'error-page.500-title',
  errorPageButtonGoToHomePage: 'error-page.button-go-to-home',
  errorPageButtonPreviousPage: 'error-page.button-previous',
  errorPageButtonReload: 'error-page.button-reload',
}
